import { render, staticRenderFns } from "./CustomerDetailsLoader.vue?vue&type=template&id=72201b78&"
import script from "./CustomerDetailsLoader.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports